import Select from 'component/Select/select'
import ProfileButton from './profile-button'
import { useLocationInfo } from 'context/location'
import Api from 'utils/api'
import { useAuth } from 'context/auth'
import Side from 'screens/admin/Docs/side'
import { useSSO } from 'context/sso'

function TopHeader() {
  const { setCurrentUser } = useAuth()
  const { locations, locationKey, saveLocationKey } = useLocationInfo()
  const { sso } = useSSO()

  const handleSelectLocation = async (e) => {
    const { value } = e.target
    const location = await locations.find((loc) => loc.api_key === value)
    const { response } = await Api('/user', 'put', {
      payload: { selected_location: location.api_key },
      notify: true,
    })
    if (response) {
      saveLocationKey(location.api_key)
      setCurrentUser(response.data)
    }
  }

  console.log('Locations', locations)

  return (
    <div className='flex items-center'>
      <div className='flex items-center '>
        {!sso && (
          <div class='mr-4'>
            <Select
              onSelect={handleSelectLocation}
              placeholder={'Select Location'}
              value={locationKey}
              options={locations.map((location) => ({
                label: location.name || location.basic_info?.name,
                value: location.api_key,
              }))}
            />
            {console.log(locations, 'check double location')}
          </div>
        )}
        <div class='mr-2'>
          <Side />
        </div>
        <div>
          <ProfileButton />
        </div>
      </div>
    </div>
  )
}

export default TopHeader
